import { defineComponent as _defineComponent } from 'vue'
import UiLink from '~/components/ui/UiLink.vue';

interface Props {
  data?: {
    id?: string;
    title?: string;
    description?: string;
    tags?: any[];
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCentersSection',
  props: {
    data: { default: () => ({
    id: '',
    title: '',
    description: '',
    tags: [],
  }) }
  },
  setup(__props: any) {



return { __sfc: true,UiLink }
}

})